import { currencyCodeEnum } from "@gap/utils/country/countryList"
import { z } from "zod"

export const CurrencyDtoSchema = z.object({
   code: z.enum(currencyCodeEnum),
   name: z.string(),
   symbol: z.string().optional(),
})

export type CurrencyDto = z.infer<typeof CurrencyDtoSchema>
